import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { AudioTranscriber, TranscribeResult } from './audio.service';
import { PendingAudio } from './audio-blob-store';

/** Real AUDIO_TRANSCRIBER: POST the WAV as multipart to the scoped transcribe route. */
export class HttpAudioTranscriber implements AudioTranscriber {
  private http = inject(HttpClient);

  async transcribe(p: PendingAudio): Promise<TranscribeResult> {
    const fd = new FormData();
    fd.append('file', p.blob, 'note.wav');
    fd.append('afsField', p.afsField);
    fd.append('slot', p.slot);
    const url = `${environment.apiUrl}/api/forms/${p.formId}/transcribe?helperId=${p.helperId}`;
    const res = await firstValueFrom(
      this.http.post<{ transcript: string; audioId: number; storageKey: string }>(url, fd));
    return { transcript: res.transcript, audioId: res.audioId };
  }
}
